module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/home-04ddd1d1d3b9267a523e9120d4f10903.png";